import React from 'react';
import {connect} from 'react-redux';
import {Redirect, Link} from 'react-router-dom'
import Snackbar from 'material-ui/Snackbar';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import withWidth, {LARGE, SMALL} from 'material-ui/utils/withWidth';
import * as colors from 'material-ui/styles/colors';

import Loading from '../components/Loading';
import Header from '../components/Header';
import LeftDrawer from '../components/LeftDrawer';
import ThemeDefault, {devThemeDefault} from '../theme-default';
import Data from '../data';

import * as actions from '../actions'

import 'bootstrap-css';

class App extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      navDrawerOpen: true
    };
  }

  componentWillMount() {
    // this.props.dispatch(actions.systemFetchLoginState());
  }

  componentWillReceiveProps(nextProps) {
    // if (this.props.width !== nextProps.width) {
    //   this.setState({navDrawerOpen: nextProps.width === LARGE});
    // }
  }

  handleChangeRequestNavDrawer() {
    this.setState({
      navDrawerOpen: !this.state.navDrawerOpen
    });
  }

  handleNavDrawerClose() {
    this.setState({
      navDrawerOpen: false
    });
  }


  render() {
    let { navDrawerOpen } = this.state;
    const paddingLeftDrawerOpen = 236;


    const {load, handleLogout, snackbar, handleSnackbarClose, auth} = this.props

    const styles = {
      header: {
        paddingLeft: navDrawerOpen ? paddingLeftDrawerOpen : 0
      },
      container: {
        margin: '80px 20px 20px 15px',
        paddingLeft: navDrawerOpen && this.props.width !== SMALL ? paddingLeftDrawerOpen : 0
      }
    };

    // return this.props.auth.isLoggedIn ? (
    return ( <MuiThemeProvider muiTheme={process.env.REACT_APP_MODE == "dev" ? devThemeDefault : ThemeDefault}>
        <div>
          <Header styles={styles.header}
                  handleChangeRequestNavDrawer={this.handleChangeRequestNavDrawer.bind(this)}
                  handleLogout={handleLogout}
                  auth={auth}/>

            <LeftDrawer navDrawerOpen={navDrawerOpen}
                        menus={Data.menus}
                        auth={auth}
                        username="User Admin"/>

            <div style={styles.container} onClick={this.handleNavDrawerClose.bind(this)}>
              {this.props.children}
            </div>

            <Loading open={load}/>

            <Snackbar
              open={snackbar.open}
              message={snackbar.message}
              autoHideDuration={4000}
              onRequestClose={handleSnackbarClose}
              bodyStyle={{backgroundColor: snackbar.color}}
            />

        </div>
      </MuiThemeProvider>
    )
    // <Redirect to='/login' />
  }
}

const mapStateToProps = (state) => ({
  load: state.global.load,
  snackbar: state.global.snackbar,
  auth: state.auth,
})

const mapStateToDispatch = (dispatch) => ({
  handleLogout: () => {dispatch(actions.userLogout())},
  handleSnackbarClose: () => {dispatch(actions.reducerSnackBar(false, ''))},
})

App = connect(
  mapStateToProps,
  mapStateToDispatch
)(App)

export default withWidth()(App);



// WEBPACK FOOTER //
// ./src/containers/App.js